import { render, staticRenderFns } from "./ChatTemplatesPage.vue?vue&type=template&id=ccbbdb92&scoped=true"
import script from "./ChatTemplatesPage.vue?vue&type=script&lang=js"
export * from "./ChatTemplatesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbbdb92",
  null
  
)

export default component.exports